<template>
  <modal :modal-key="'confirm_purchase_via_sms'" :class-style="'modal--welcomeback modal--zero-balance'"
         @close="$emit('close')">
        <template slot="header">
          <h1>{{ getTranslations.home_modals_confirm_purchase_purchase }}</h1>
          <img class="usericon" src="static/images/happy_face_2.svg" alt="">
        </template>
        <template slot="body">
          <p class="modal_strong" v-if="!getBundleData.joker">
            {{ getBundleData.numberOfGames?getBundleData.numberOfGames + ' ' + getTranslations.home_modals_confirm_purchase_games:'' }}
              {{ getBundleData.numberOfGames && getBundleData.points ?getTranslations.home_modals_confirm_purchase_and:'' }}
             {{ getBundleData.points?getBundleData.points + ' ' + getTranslations.home_modals_confirm_purchase_points:''}}
            – {{ getBundleData.price
            }} {{ getBundleData.currencyCode }}</p>
          <p class="modal_strong"  v-else>
            {{ getBundleData.numOfJokers }}  {{ getTranslations.home_modals_confirm_purchase_jokers }} – {{ getBundleData.price
            }} {{ getBundleData.currencyCode }}</p>
          <p v-if="getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_jokers_increase }}</p>
          <p v-if="getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_via_sms_confirm_your_purchase_by }} </p>

          <p v-if="!getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_via_sms_playing_more }}</p>
          <p v-if="!getBundleData.joker">{{ getTranslations.home_modals_confirm_purchase_via_sms_purchase_now_by }} </p>
        </template>
  </modal>
</template>

<script>
  /* eslint no-console: "off", no-param-reassign: ["error", { "props": false }], no-use-before-define: ["error", { "variables": false }] */
import { mapGetters } from 'vuex';
import Modal from '@/components/home/modals/shared/GenericModal';


export default {
  name: 'confirmPurchaseViaSms',
  components: {
    Modal,
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapGetters('profile', [
      'getBundleData',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/ConfirmPurchaseViaSms.vue